<template>
  <div class="mynews">
    <v-header :goBack='goBack' :mine='true'></v-header>
    <span class="title">{{$t('mynewsedit.EditMasterNews')}}</span>
    <!--上传图片-->
    <div class="head-img">
      <div class="head_img">
        <img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg" :onerror="errorImg" style="margin: auto;display: block; margin-top: 10px;" v-show="isshow" />
        <canvas ref="can" v-show="showflag" style="width: 5.2rem;height: 5.2rem;overflow: hidden;margin: auto;display: block;border-radius: 50%;" @click.stop="uploadHeadImg"></canvas>
      </div>
      <input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />
      <p style="font-size: 0.8rem;line-height: 1.6rem;color: #3f3f3f;text-align: center;">{{$t('mynewsedit.setImg')}}</p>
    </div>

    <div class="news">
      <div class="pos"><span>{{$t('mynews.mastername')}}</span><input v-model="nich" :placeholder="$t('mynewsedit.EnterMastername')" maxlength="12">
        <!-- <p class="danger" v-show='flag2'>只能中英文，数字，下划线，减号</p> -->
      </div>
      <div class="pos"><span>{{$t('mynews.mastersex')}}</span>
        <!-- <select   style="width: 80%;box-sizing: border-box;padding-left: 10px;border: 0;border-bottom: 1px solid #dadada;background: transparent;">
						<option v-for="(item,index) in sex" :key="index" :value="item" style="text-align: center;" @click="sexselect(index)" ref='ww'>
							<span style="text-align: center;">{{item}}</span>
						</option>
					</select> -->
        <el-select class="sel" v-model="value" :placeholder="$t('mynewsedit.ChoiceSex')">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="pos"><span>{{$t('mynews.masteremail')}}</span><input v-model="email" :placeholder="$t('forgetpassword.EnterEmail')" class="input"></div>
      <p class="denger" v-show="flag3">{{$t('forgetpassword.NotEmail')}}</p>
      <p class="denger" v-show="flag4">{{$t('forgetpassword.FalseEmail')}}</p>
      <div class="pos"><span>{{$t('mynews.masterphone')}}</span><input v-model="phone" :placeholder="$t('mynewsedit.EnterMasterphone')" class="input"></div>
      <p class="denger" v-show="flag5">{{$t('forgetpassword.FalsePhone')}}</P>
      <p class="denger" v-show="flag6">{{$t('forgetpassword.NotPhone')}}</P>
      <div class="pos"><span>{{$t('mynews.masteradr')}}</span><input v-model="adr" :placeholder="$t('mynewsedit.EnterMasteradr')" class="input"></div>
      <el-button @click="finish">{{$t('mynewsedit.finish')}}</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { updateUserInfo, updateBasicInfo } from "../../api/index.js";
import { getLoginUser } from "../../api/index.js";
import Qs from "qs";
import Axios from "axios";
import EXIF from "exif-js/exif.js";
import header from "../../components/header";
export default {
    name: "mynewsedit",
    inject: ["reload"],
    data() {
        return {
            imgflag: true,
            avatar: require("../../image/addmypet.png"),
            avatar1: "",
            errorImg: 'this.src="' + require("../../image/addmypet.png") + '"',
            options: [
                {
                    value: true,
                    label: this.$t("mynewsedit.boy")
                },
                {
                    value: false,
                    label: this.$t("mynewsedit.girl")
                }
            ],
            value: "",
            nich: "",
            email: "",
            isshow: true,
            showflag: false,
            phone: "",
            username: "",
            adr: "",
            id: "",
            goBack: false,
            flag: true,
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false,
            flag5: false,
            flag6: false,
            picImg: "",
            upload: this.$t("mynewsedit.failure")
        };
    },
    components: {
        "v-header": header
    },
    created() {
        if (sessionStorage.third) {
            this.flag = false;
        }
        getLoginUser()
            .then(res => {
                console.log("111", res.data);

                //邮箱注册第一次登录显示的信息
                this.username = res.data.data.username;
                let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
                if(reg.test(this.username)){
                    this.email = this.username
                }
                if(reg1.test(this.username)){
                    this.phone = this.username
                }

                this.nich = res.data.data.nickname;
                this.value = res.data.data.sex;
                //this.email = res.data.data.email;
                //this.phone = res.data.data.mobile;
                this.adr = res.data.data.address;
                if (res.data.data.photoUrl) {
                    this.avatar = res.data.data.photoUrl;
                }
            })
            .catch(error => {
                console.log(error);
            });
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id == 1) {
            this.goBack = true;
        } else {
            this.goBack = false;
        }
    },
    methods: {
        // 打开图片上传
        uploadHeadImg: function() {
            //@click.stop阻止点击事件继续传播
            // this.$confirm("是否修改头像?", "提示", {
            //   //弹窗
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            //   type: "warning"
            // })
            //   .then(() => {
            //     this.$el.querySelector(".hiddenInput").click();
            //   })
            //   .catch(() => {});
            this.$el.querySelector(".hiddenInput").click();
        },
        // 将头像显示
        handleFile: function(e) {
            var th = this;
            th.imgflag = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                console.log("data", data);
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag = false;
                    th.isshow = true;
                    th.avatar = res.result;
                    th.picImg = data.target.result.split(",")[1];
                } else {
                    th.compress(res.result, Orientation);
                }
            };
        },
        compress(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag = true;
            th.isshow = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    //解决苹果手机拍照问题
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 1);
                th.picImg = base64.split(",")[1];
                th.avatar = base64.result;
            };
        },
        finish() {
            let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
            let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
            // if (reg.test(this.email) && reg1.test(this.phone)) {
                this.flag3 = false;
                this.flag4 = false;
                this.flag5 = false;
                this.flag6 = false;
                if (this.picImg == "") {
                    var params = Qs.stringify({
                        nickname: this.nich,
                        sex: this.value,
                        mobile: this.phone,
                        email: this.email,
                        address: this.adr
                    });
                } else {
                    var params = Qs.stringify({
                        nickname: this.nich,
                        sex: this.value,
                        mobile: this.phone,
                        email: this.email,
                        photoUrl: this.picImg,
                        address: this.adr
                    });
                }
                updateBasicInfo(params) //修改用户基本信息
                    .then(res => {
                        // console.log("提交返回：", res);
                        if (res.data.header.status == "1000") {
                        console.log('邮箱注册成功，用户信息更新成功！')
                        this.$router.push({
					                name: "login",
					                query: {
					                  accessToken: localStorage.token,
					                  deviceCode: localStorage.codeId
					                }
				              	});
                            // this.reload()
                        } else {
                            this.$message({
                                message: this.upload,
                                type: "warning"
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            // } else {
            //     if (this.email == undefined) {
            //         this.flag3 = true;
            //         this.flag4 = false;
            //     } else {
            //         if (this.email.length == 0) {
            //             this.flag3 = true;
            //             this.flag4 = false;
            //         } else {
            //             if (reg.test(this.email)) {
            //                 this.flag3 = false;
            //                 this.flag4 = false;
            //             } else {
            //                 this.flag3 = false;
            //                 this.flag4 = true;
            //             }
            //         }
            //     }

            //     if (this.phone == undefined) {
            //         this.flag6 = true;
            //         this.flag5 = false;
            //     } else {
            //         if (this.phone.length == 0) {
            //             this.flag6 = true;
            //             this.flag5 = false;
            //         } else {
            //             if (reg1.test(this.phone)) {
            //                 this.flag6 = false;
            //                 this.flag5 = false;
            //             } else {
            //                 this.flag6 = false;
            //                 this.flag5 = true;
            //             }
            //         }
            //     }
            // }
        },
        goback() {
            this.$router.go(-1);
        }
    }
};
</script>
<style>
.sel {
    width: 75%;
    box-sizing: border-box;
    text-align: right;
    /* border-bottom: 1px solid #dadada; */
}
.sel .el-input {
    height: 2.4rem;
    line-height: 2.4rem;
    text-align: right;
}
.sel .el-input__inner {
    border-radius: 0;
    border: 0;
    /* border-bottom: 1px solid #dadada;
  box-sizing: border-box; */
    /* padding-left: 10px; */
    font-size: 0.8rem;
    height: 2.4rem;
    line-height: 2.4rem;
    color: #3f3f3f;
    text-align: right;
}
</style>
>
<style scoped>
/*头部*/
.title {
    padding-top: 5px;
    font-size: 0.8rem;
    display: block;
    color: #828282;
    text-align: center;
}
.logo {
    text-align: center;
    width: 50%;
    margin: 0 auto;
    margin-top: 8px;
}

.logo img {
    width: 100%;
}

.pro_pic {
    width: 100%;
    text-align: center;
    margin: 0.5rem 0;
}
.pro_pic img {
    width: 5.2rem;
    height: 5.2rem;
    border-radius: 50%;
}
/*信息*/
.news {
    width: 90%;
    margin: 0 auto;
}
.news .pos {
    width: 100%;
    height: 2.6rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dadada;
}
.pos input {
    border-radius: 0;
    width: 80%;
    border: 0px;
    /* border-bottom: 1px solid #dadada; */
    box-sizing: border-box;
    padding-left: 10px;
    font-size: 0.8rem;
    color: #3f3f3f;
    text-align: right;
}
.pos input:focus,
.pos select:focus {
    outline: none;
}
.news span {
    margin: auto 0;
    /* width: 20%; */
    /* height: 2.6rem; */
    /* line-height: 2.6rem; */
    /* border-bottom: 1px solid #dadada; */
    box-sizing: border-box;
    font-size: 0.8rem;
    white-space: nowrap;
    text-align: left;
    padding: 0 0;
    position: relative;
}
/* .news span:before {
  width: 1px;
  height: 0.6rem;
  background: #dadada;
  display: block;
  content: "";
  position:absolute;
  top: 25%;
  right:0px;
} */
.news .el-button {
    /* width: 100%;
    background: #095196;
    color: #ffffff;
    margin: 2rem 0;
    padding: 0 0;
    border-color: #095196;
    height: 2.6rem;
    line-height: 2.6rem; */
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
.denger {
    font-size: 0.625rem;
    margin-top: 5px;
    color: red;
}
/*上传图片*/
.head_img img {
    width: 5.2rem;
    height: 5.2rem;
    border-radius: 50%;
    overflow: hidden;
}
.hiddenInput {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/mynewsedit.vue